/* ============================================================
   Charm Upsell Popup – charm-upsell-popup.js
   Helye: assets/charm-upsell-popup.js
   
   Trigger feltételek:
   1. A kosárba rakott termék a "charmok" kollekcióból való
   2. A kosárérték 13.000 Ft felett van
   3. A kosárérték 19.000 Ft alatt van
   ============================================================ */

(function () {
  'use strict';

  var CONFIG = {
    collectionHandle: 'charmok',
    cartMin: 13000,   // Ft
    cartMax: 19000,   // Ft
    offerPrice: 4000, // Ft
    cooldownMinutes: 60,
  };

  var popup = {
    overlay: null,
    currentVariantId: null,
    allCharms: [],
    lastShown: null,

    init: function () {
      popup.overlay = document.getElementById('charm-upsell-overlay');
      if (!popup.overlay) return;
      popup.bindEvents();
      popup.interceptFetch();
    },

    bindEvents: function () {
      var closeBtn = document.getElementById('charm-upsell-close');
      var skipBtn  = document.getElementById('charm-upsell-skip');
      var addBtn   = document.getElementById('charm-upsell-add');
      var backdrop = popup.overlay.querySelector('.charm-upsell-backdrop');

      if (closeBtn) closeBtn.addEventListener('click', popup.close);
      if (skipBtn)  skipBtn.addEventListener('click', popup.close);
      if (addBtn)   addBtn.addEventListener('click', popup.addToCart);
      if (backdrop) backdrop.addEventListener('click', popup.close);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') popup.close();
      });
    },

    // Fetch elfogás – /cart/add.js hívásokat kapjuk el
    interceptFetch: function () {
      var originalFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url  = typeof args[0] === 'string' ? args[0] : '';

        return originalFetch.apply(this, args).then(function (response) {
          if (url.includes('/cart/add')) {
            // Klónozzuk hogy kétszer olvasható legyen
            var cloned = response.clone();
            cloned.json().then(function (addedItem) {
              // Ellenőrizzük hogy charmok kollekcióból való-e
              popup.checkIfCharmAndShow(addedItem);
            }).catch(function () {});
          }
          return response;
        });
      };
    },

    // Ellenőrzés: charm kollekcióból való-e + kosárérték
    checkIfCharmAndShow: function (addedItem) {
      // Lekérjük a termék kollekciót
      var productHandle = addedItem.handle || '';
      if (!productHandle) return;

      fetch('/products/' + productHandle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (product) {
          // Ellenőrzük a collections-t a termék URL-jén keresztül
          // Mivel Shopify JS API nem adja vissza a kollekciót,
          // a termék URL-jét ellenőrizzük a charmok oldalon
          popup.isInCharmsCollection(productHandle, function (isCharm) {
            if (!isCharm) return;

            // Kosárérték lekérése
            fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var totalHUF = Math.round(cart.total_price / 100);

                if (totalHUF < CONFIG.cartMin || totalHUF > CONFIG.cartMax) return;

                // Cooldown ellenőrzés
                if (popup.lastShown) {
                  var elapsed = (Date.now() - popup.lastShown) / 60000;
                  if (elapsed < CONFIG.cooldownMinutes) return;
                }

                popup.lastShown = Date.now();
                popup.loadRandomCharm();
              });
          });
        })
        .catch(function () {});
    },

    // Ellenőrzés hogy a termék a charmok kollekcióban van-e
    isInCharmsCollection: function (productHandle, callback) {
      fetch('/collections/' + CONFIG.collectionHandle + '/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = data.products || [];
          var found = products.some(function (p) {
            return p.handle === productHandle;
          });
          callback(found);
        })
        .catch(function () { callback(false); });
    },

    // Random charm betöltése
    loadRandomCharm: function () {
      if (popup.allCharms.length > 0) {
        popup.showPopup(popup.pickRandom(popup.allCharms));
        return;
      }

      fetch('/collections/' + CONFIG.collectionHandle + '/products.json?limit=50')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var available = (data.products || []).filter(function (p) {
            return p.variants && p.variants.some(function (v) { return v.available; });
          });
          if (!available.length) return;
          popup.allCharms = available;
          popup.showPopup(popup.pickRandom(available));
        })
        .catch(function () {});
    },

    pickRandom: function (arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    },

    // Popup megjelenítése
    showPopup: function (product) {
      var variant = product.variants.find(function (v) { return v.available; });
      if (!variant) return;

      popup.currentVariantId = variant.id;

      // Szövegek
      document.getElementById('charm-upsell-name').textContent  = product.title;
      document.getElementById('charm-upsell-price').textContent = popup.formatPrice(CONFIG.offerPrice);

      // Kép
      var img    = document.getElementById('charm-upsell-img');
      var loader = document.getElementById('charm-upsell-img-loader');
      img.style.opacity = '0';
      if (loader) loader.classList.remove('hidden');

      var imgSrc = product.images && product.images[0]
        ? popup.resizeImage(product.images[0].src, '300x300')
        : '';

      if (imgSrc) {
        img.onload = function () {
          img.style.opacity = '1';
          if (loader) loader.classList.add('hidden');
        };
        img.src = imgSrc;
        img.alt = product.title;
      } else {
        img.style.opacity = '1';
        if (loader) loader.classList.add('hidden');
      }

      // Gomb szöveg
      var addBtn = document.getElementById('charm-upsell-add');
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Kosárba Rakom – ' + popup.formatPrice(CONFIG.offerPrice);
      }

      // Megjelenítés
      popup.overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      setTimeout(function () {
        var closeBtn = document.getElementById('charm-upsell-close');
        if (closeBtn) closeBtn.focus();
      }, 100);
    },

    // Kosárba rakás
    addToCart: function () {
      if (!popup.currentVariantId) return;

      var addBtn = document.getElementById('charm-upsell-add');
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Hozzáadás...';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: popup.currentVariantId,
          quantity: 1,
          properties: { '_upsell': 'true' }
        })
      })
      .then(function () {
        popup.close();
        // Kaching Cart frissítés
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {
        if (addBtn) {
          addBtn.disabled = false;
          addBtn.textContent = 'Próbáld újra';
        }
      });
    },

    close: function () {
      if (!popup.overlay) return;
      popup.overlay.style.display = 'none';
      document.body.style.overflow = '';
    },

    formatPrice: function (huf) {
      return huf.toLocaleString('hu-HU') + ' Ft';
    },

    resizeImage: function (src, size) {
      return src.replace(/(\.[^.]+)(\?.*)?$/, '_' + size + '$1$2');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', popup.init.bind(popup));
  } else {
    popup.init();
  }

})();